import { Box } from "@chakra-ui/react";
import { createContext, useContext, type ReactNode } from "react";
import LoadingThreeDotsJumping from "../Indicator/JumpingDot";
import { useMinDelayLoading } from "../../hooks/useMinDelayLoading";

interface ChatDeleteLoadingContextValue {
    start: () => void;
    done: (afterComplete?: () => void) => void;
    error: () => void;
}

const ChatDeleteLoadingContext = createContext<ChatDeleteLoadingContextValue | null>(null);

interface ChatDeleteLoadingProviderProps {
    children: ReactNode;
    onComplete?: () => void;
}

export function ChatDeleteLoadingProvider({
    children,
    onComplete,
}: ChatDeleteLoadingProviderProps) {
    const { isLoading, start, done, error } = useMinDelayLoading({ onComplete });

    return (
        <ChatDeleteLoadingContext.Provider value={{ start, done, error }}>
            {children}
            {isLoading && (
                <Box
                    position="fixed"
                    inset={0}
                    zIndex={9999}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    pointerEvents="none"
                >
                    <LoadingThreeDotsJumping />
                </Box>
            )}
        </ChatDeleteLoadingContext.Provider>
    );
}

export function useChatDeleteLoading() {
    return useContext(ChatDeleteLoadingContext);
}
